/* eslint-disable */
import React, { Component } from 'react'

// #49526c

import Svg, {
    Circle,
    Ellipse,
    G,
    LinearGradient,
    RadialGradient,
    Line,
    Path,
    Polygon,
    Polyline,
    Rect,
    Symbol,

    Use,
    Defs,
    Stop
} from 'react-native-svg';

export const SvgBlueBarCoder = ({ size }) => {
    return (<Svg
        height={size}
        width={size}
        viewBox="0 0 540.06 396.07" >
        <Defs></Defs>

        <Path class="cls-1" fill="#000000" d="M516,24c-19.68,0-38.65,0-57.62,0a24.42,24.42,0,0,1-5.46-.35c-5.77-1.34-9.95-7-9.45-12.48A12.3,12.3,0,0,1,455.57.07c5.33-.14,10.66,0,16,0,18.49,0,37,0,55.47,0,7.74,0,12.95,5.11,13,12.78q.12,35.23,0,70.46c0,7.26-5.27,12.78-11.87,12.84-6.82.06-12.06-5.52-12.09-13.11-.06-17.66,0-35.31,0-53C516,28.25,516,26.45,516,24Z" />
        <Path class="cls-1" fill="#000000" d="M24,372c19.6,0,38.55,0,57.51,0a22.59,22.59,0,0,1,5.44.4,12.23,12.23,0,0,1,9.11,12.69c-.5,5.55-5.47,10.75-11.29,10.79q-36.7.25-73.41,0c-6.21,0-11.26-5.52-11.3-11.83q-.18-36.21,0-72.41A11.84,11.84,0,0,1,11.88,299.9c6.65,0,12.08,5.47,12.12,12.6.09,17.81,0,35.62,0,53.44C24,367.75,24,369.56,24,372Z" />
        <Path class="cls-1" fill="#000000" d="M24,24c0,2.29,0,4.07,0,5.86,0,17.64,0,35.28,0,52.93,0,7.65-5.12,13.25-11.9,13.31S.07,90.6.06,83q-.08-35,0-69.9C.08,5,5.09.07,13.16.05q34.7-.06,69.4,0c8,0,13.64,5.14,13.56,12.13S90.38,24,82.27,24C63.13,24.06,44,24,24,24Z" />
        <Path class="cls-1" fill="#000000" d="M516,372c0-18.22,0-35.83,0-53.45,0-2.16-.06-4.33,0-6.49.25-7,5.4-12.24,11.92-12.17a12.16,12.16,0,0,1,12,12.17c.14,16,0,32,0,47.94,0,7.49,0,15,0,22.47-.06,8.35-5,13.48-13.28,13.5q-34.71.08-69.42,0c-7.7,0-13.3-5-13.4-11.8-.11-7,5.54-12.16,13.51-12.18C476.72,372,496,372,516,372Z" />
        <Path class="cls-1" fill="#000000" d="M270.3,186h236a47.28,47.28,0,0,1,5,.08,12,12,0,0,1,.2,23.81,40.49,40.49,0,0,1-5,.11H33.55a39.65,39.65,0,0,1-5-.11,12,12,0,0,1,.29-23.81,48.7,48.7,0,0,1,5-.08Z" />
        <Path class="cls-1" fill="#000000" d="M161.68,161.8H114.3V66.13A11.7,11.7,0,0,1,126,54.43h24a11.7,11.7,0,0,1,11.7,11.7Z" />
        <Path class="cls-1" fill="#000000" d="M329.68,161.8H282.3V66.13A11.7,11.7,0,0,1,294,54.43h24a11.7,11.7,0,0,1,11.7,11.7Z" />
        <Path class="cls-1" fill="#000000" d="M318,341.8H294a11.69,11.69,0,0,1-11.69-11.69V234.42h47.39v95.69A11.69,11.69,0,0,1,318,341.8Z" />
        <Path class="cls-1" fill="#000000" d="M150,341.81H126a11.69,11.69,0,0,1-11.69-11.69V234.43h47.38v95.69A11.69,11.69,0,0,1,150,341.81Z" />
        <Path class="cls-1" fill="#000000" d="M462,341.79h0a11.69,11.69,0,0,1-11.69-11.69V234.42h23.4v95.68A11.69,11.69,0,0,1,462,341.79Z" />
        <Path class="cls-1" fill="#000000" d="M414,341.79h0a11.69,11.69,0,0,1-11.69-11.69V234.42H425.7V330.1A11.69,11.69,0,0,1,414,341.79Z" />
        <Path class="cls-1" fill="#000000" d="M377.85,234.26V330a11.69,11.69,0,0,1-11.69,11.69H366A11.69,11.69,0,0,1,354.3,330V234.26Z" />
        <Path class="cls-1" fill="#000000" d="M234.25,330V234.3h23.39V330A11.69,11.69,0,0,1,246,341.66h0A11.69,11.69,0,0,1,234.25,330Z" />
        <Path class="cls-1" fill="#000000" d="M186.39,234.24h23.37V330.1a11.69,11.69,0,0,1-11.69,11.69h0a11.69,11.69,0,0,1-11.69-11.69Z" />
        <Path class="cls-1" fill="#000000" d="M78,341.81h0A11.69,11.69,0,0,1,66.3,330.12V234.26H89.68v95.86A11.69,11.69,0,0,1,78,341.81Z" />
        <Path class="cls-1" fill="#000000" d="M462.07,54.26h0A11.7,11.7,0,0,1,473.78,66v95.67H450.37V66A11.7,11.7,0,0,1,462.07,54.26Z" />
        <Path class="cls-1" fill="#000000" d="M414.07,54.26h0A11.7,11.7,0,0,1,425.78,66v95.67H402.37V66A11.7,11.7,0,0,1,414.07,54.26Z" />
        <Path class="cls-1" fill="#000000" d="M377.69,161.8h-23.4V66.13A11.7,11.7,0,0,1,366,54.43h0a11.7,11.7,0,0,1,11.7,11.7Z" />
        <Path class="cls-1" fill="#000000" d="M234.26,161.67V66A11.7,11.7,0,0,1,246,54.29h0A11.7,11.7,0,0,1,257.65,66v95.68Z" />
        <Path class="cls-1" fill="#000000" d="M209.7,161.79H186.28V66.12A11.7,11.7,0,0,1,198,54.42h0a11.7,11.7,0,0,1,11.7,11.7Z" />
        <Path class="cls-1" fill="#000000" d="M78.07,54.26h0A11.7,11.7,0,0,1,89.78,66v95.67H66.37V66A11.7,11.7,0,0,1,78.07,54.26Z" />
    </Svg>)
}

